import SEO from "../components/SEO";
import seoData from "../seoData";
import BreadcrumbSchema from "../components/BreadcrumbSchema";
import { Contact } from "../components/contact";
import JsonData from "../data/data.json";

const ContactPage = () => (
  <>
    {/* SEO Meta */}
    <SEO {...seoData.contact} />
    <BreadcrumbSchema
        items={[
            { name: "Home", url: "/" },
            { name: "Contact", url: "/contact" },
        ]}
    />
    <Contact data={JsonData.Contact} />
  </>
);

export default ContactPage;
